import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, Row, Col, message } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapLocationDot, faCalendarDays, faRankingStar } from '@fortawesome/free-solid-svg-icons';
import Slider from "react-slick";
import { api } from '../AppConfig';
import { motion } from 'motion/react';
import front_image from '../assets/banner_lpi.png';
import TournamentCard from '../components/TournamentCard';


function Home(props) {
  const [upcoming, setUpcoming] = useState([]);
  const [messageApi, contextHolder] = message.useMessage();
  const basepath = process.env.PUBLIC_URL
  ? `${process.env.PUBLIC_URL}`
  : '/'; 

  const carouselSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4
  };

  useEffect(() => {
      fetch(api.tournaments().upcoming().href)
      .then(res => res.json())
      .then(
        (result) => {
          setUpcoming(result.payLoad);
        },
        (error) => {
          messageApi.error('There was an error fetching upcoming tournaments! Retry later.')
          // setError(error); 
        }
      )
  }, [props, messageApi])

  return (
    <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
    {contextHolder}
    <div 
      className="banner-home" 
      style={{ backgroundImage: `url(${front_image})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center'}} 
    >
        <p></p>
        <div style={{display: 'block', verticalAlign: 'middle', opacity: '0'}}>
            <p className="banner-title">LEGA PAUPER ITALIA</p>
        </div>
        <div className="indicator"></div>
    </div>
    <div style={{ textAlign: 'center', fontSize: '16px', marginBottom: '20px' }}>
      <Row style={{ padding: '0 50px' }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <h1>ABOUT</h1>
        </Col>
      </Row>
      <Row gutter={16} style={{ padding: '0 100px' }} >
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <p style={{ fontSize: '16px' }}>
            Lega Pauper Italia (LPI) is the leading organization for the Pauper format of Magic: The Gathering in Italy. LPI fosters competitive play and community growth through a network of affiliated leagues, local tournaments, and major events like IPT (international Pauper Tour) and Paupergeddon.
          </p>
          <p style={{ fontSize: '16px' }}>
            The Paupergeddon is LPI’s flagship event—an open, international tournament where hundreds of players compete for glory and record-breaking prize pools. It takes place three times a year: in Rome (Autumn Edition), Milan (Winter Edition), and Pisa (Spring Edition), marking the pinnacle of the competitive Pauper season.
          </p>
          <p style={{ fontSize: '16px' }}>
            With its competitive spirit and inclusive nature, Paupergeddon is the ultimate battleground for Pauper enthusiasts!
          </p>
        </Col>
      </Row>
    </div>
    <div style={{ textAlign: 'center', fontSize: '16px', backgroundColor: '#001529' }}>
      <Row style={{ padding: '5px 50px', color: '#ffffff' }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <h1>QUICK ACTIONS</h1>
        </Col>
      </Row>
      <Row style={{ padding: '5px 100px', justifyContent: 'space-evenly' }}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} style={{ alignItems: 'center' }} >
          <Link to={`${basepath}leagues`} viewTransition>
            <Card className="rules-card" title="JOIN A LEAGUE">
              <FontAwesomeIcon icon={faMapLocationDot} style={{ fontSize: '90px', color: '578FCA', marginBottom: '30px' }}/>
              <h1 style={{ color: '#fff' }}>VIEW LEAGUES</h1>
            </Card>
          </Link>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} style={{ alignItems: 'center' }}>
          <Link to={`${basepath}tournaments`} viewTransition>
            <Card className="rules-card" title="PARTICIPATE TO A TOURNAMENT">
              <FontAwesomeIcon icon={faCalendarDays} style={{ fontSize: '90px', color: '578FCA', marginBottom: '30px' }}/>
              <h1 style={{ color: '#fff' }}>VIEW TOURNAMENTS</h1>
            </Card>
          </Link>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8} style={{ alignItems: 'center' }}>
          <Link to={`${basepath}rankings`} viewTransition>
            <Card className="rules-card" title="CLIMB THE LADDER">    
                <FontAwesomeIcon icon={faRankingStar} style={{ fontSize: '90px', color: '578FCA', marginBottom: '30px' }}/>
                  <h1 style={{ color: '#fff' }}>VIEW LPI RANKING</h1>
            </Card>
          </Link>
        </Col>
      </Row>
    </div>
    <div style={{ textAlign: 'center', fontSize: '16px', marginBottom: '20px' }}>
      <Row style={{ padding: '0 50px' }}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
          <h1>UPCOMING EVENTS</h1>
        </Col>
      </Row>
      <div className="slider-container" style={{ padding: '0 60px' }}>
        <Slider {...carouselSettings}>
          {
            upcoming.map(event => (
              <Link to ={`${basepath}tournaments/${event.id}`} viewTransition>
                <TournamentCard tournament={event} />
              </Link>
            ))
          }
        </Slider>
      </div>
    </div>
    </motion.div>
  );
}

export default Home;